// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Users_title__V\\+vbJ {
  padding: 20px;
}
.Users_containerList__2kTZs {
  padding: 20px !important;
}
.Users_mas__bepuH {
  text-decoration: none;
  text-align: left;
  cursor: pointer;
  color: rgb(239, 116, 16) !important;
  margin-right: 5px;
  font-size: 15px !important;

  padding: 5px;
}

th {
  background-color: #063c62 !important;
  color: white !important;
  font-weight: initial !important;
}
.Users_botonesTabla__qaAdX {
  border: 1px #063c62 !important;
}


.Users_error_message__i\\+HQj {
  display: flex;
  justify-content: center;
  font-size: 22px;
}
/* admin */
.Users_btndisabled__6qG7B{
    border-Radius:20% ;
     border:none ;
    background: none;
} 
.Users_btndisabled__6qG7B:hover{
    background-Color:#e5ebed !important
}
table{
  box-shadow: rgba(149, 121, 107, 0.175) 2px 2px 8px !important;
}
.Users_modal__BHEWJ {
  position: relative;
  width: 80%; /* Ajusta el tamaño según sea necesario */
  max-height: 90vh; /* Limita la altura máxima del modal */
  overflow-y: auto; /* Permite que el contenido sea desplazable */
  margin: auto;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  margin-left: 300px;
}

.Users_Overlay__exJ-2 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(252, 252, 252); /* Fondo oscuro detrás del modal */
}
/*  */

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .Users_containerList__2kTZs {
    font-size: 12px;
    width: 600px;
  }
  .Users_mas__bepuH {
    font-size: 11px !important;
  }
  .Users_reverso__sIXs5{
    margin-left: 20% !important;
  }
 
}
@media only screen and (max-width: 767px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/Users.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,0BAA0B;;EAE1B,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA,UAAU;AACV;IACI,kBAAkB;KACjB,YAAY;IACb,gBAAgB;AACpB;AACA;IACI;AACJ;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,kBAAkB;EAClB,UAAU,EAAE,yCAAyC;EACrD,gBAAgB,EAAE,sCAAsC;EACxD,gBAAgB,EAAE,6CAA6C;EAC/D,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC,EAAE,kCAAkC;AAC1E;AACA,KAAK;;AAEL;EACE;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;;AAEF;AACA;AACA","sourcesContent":[".title {\n  padding: 20px;\n}\n.containerList {\n  padding: 20px !important;\n}\n.mas {\n  text-decoration: none;\n  text-align: left;\n  cursor: pointer;\n  color: rgb(239, 116, 16) !important;\n  margin-right: 5px;\n  font-size: 15px !important;\n\n  padding: 5px;\n}\n\nth {\n  background-color: #063c62 !important;\n  color: white !important;\n  font-weight: initial !important;\n}\n.botonesTabla {\n  border: 1px #063c62 !important;\n}\n\n\n.error_message {\n  display: flex;\n  justify-content: center;\n  font-size: 22px;\n}\n/* admin */\n.btndisabled{\n    border-Radius:20% ;\n     border:none ;\n    background: none;\n} \n.btndisabled:hover{\n    background-Color:#e5ebed !important\n}\ntable{\n  box-shadow: rgba(149, 121, 107, 0.175) 2px 2px 8px !important;\n}\n.modal {\n  position: relative;\n  width: 80%; /* Ajusta el tamaño según sea necesario */\n  max-height: 90vh; /* Limita la altura máxima del modal */\n  overflow-y: auto; /* Permite que el contenido sea desplazable */\n  margin: auto;\n  padding: 20px;\n  background-color: white;\n  border-radius: 8px;\n  margin-left: 300px;\n}\n\n.Overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgb(252, 252, 252); /* Fondo oscuro detrás del modal */\n}\n/*  */\n\n@media only screen and (min-width: 768px) and (max-width: 1023px) {\n  .containerList {\n    font-size: 12px;\n    width: 600px;\n  }\n  .mas {\n    font-size: 11px !important;\n  }\n  .reverso{\n    margin-left: 20% !important;\n  }\n \n}\n@media only screen and (max-width: 767px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Users_title__V+vbJ`,
	"containerList": `Users_containerList__2kTZs`,
	"mas": `Users_mas__bepuH`,
	"botonesTabla": `Users_botonesTabla__qaAdX`,
	"error_message": `Users_error_message__i+HQj`,
	"btndisabled": `Users_btndisabled__6qG7B`,
	"modal": `Users_modal__BHEWJ`,
	"Overlay": `Users_Overlay__exJ-2`,
	"reverso": `Users_reverso__sIXs5`
};
export default ___CSS_LOADER_EXPORT___;
